import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, AuthenticationService, RAFUnitOfWork, UtilityService } from 'src/app/core/core.module';
import * as moment from 'moment';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import DataSource from 'devextreme/data/data_source';
import { Subject } from 'rxjs';
import validationEngine from 'devextreme/ui/validation_engine';
import { JobType } from 'src/app/core/data/entities';

@Component({
    selector: 'app-job-dialog',
    templateUrl: './job-dialog.component.html',
    styleUrls: ['./job-dialog.component.scss'],
    standalone: false
})
export class JobDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    mode = 'new';
    statuses: any;
    job: any;
    jobId: number;
    customers: any;
    validationGroup = 'mainValidationGroup';
    errorAction = 'saving';

    readOnly = false;
    jobTypes: JobType[];

    constructor(
        public modalRef: BsModalRef,
        private uow: RAFUnitOfWork,
        private auth: AuthenticationService,
        private appInfo: AppInformationService,
        private modalService: BsModalService,
        private route: ActivatedRoute,
        private router: Router,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        this.statuses = this.uow.lookups.statuses;
        this.jobTypes = await this.uow.getActiveJobTypes();
        // this.customerType = ['Business', 'Residential'];
        this.customers = await this.uow.getCustomerNames();

        if (!!this.jobId) {
            this.job = (await this.uow.jobs.byId(this.jobId)) as any;
            this.mode = 'edit';
            // console.log(this.job);
        } else {
            this.mode = 'new';
            // const jobNumber = await this.utility.getNextJobNumber();
            const jobNumber = (await this.uow.getNextJobNumberBasedOnMax() as any).jobNumber;
            this.job = this.uow.jobs.createEntity(); // as WorkOrder
            this.job.created = new Date();
            this.job.statusId = 1;
            this.job.jobNumber = Number(jobNumber) + 1;
            this.job.createdById = this.auth.userValue.id;
            this.job.jobTypeId = 1;
        }
    }

    setReadOnly() {
        if (this.job.statusId === 4 || this.job.statusId === 6) this.readOnly = true;
        else this.readOnly = false;
    }

    async customerSelected(e) {
        const existingCustomer = await this.uow.getCustomerBillingInformation(e.selectedItem);
        if (!!existingCustomer) {
            this.job.contactName = existingCustomer.contactName;
            this.job.billingAddress1 = existingCustomer.billingAddress1;
            this.job.billingAddress2 = existingCustomer.billingAddress2;
            this.job.billingCity = existingCustomer.billingCity;
            this.job.billingState = existingCustomer.billingState;
            this.job.billingZip = existingCustomer.billingZip;
        }
    }

    startDateChanged = (e) => {
        if (this.job.allDay) return;
        const endMoment = moment(e.value).add(1, 'hours');
        this.job.endDate = endMoment.toDate();
    // tslint:disable-next-line: semicolon
    };

    allDaySelected = (e) => {
        if (!this.job.allDay) return;
        const startMoment = moment(this.job.startDate).startOf('day');
        const endMoment = moment(this.job.startDate).add(1, 'days').startOf('day');
        this.job.startDate = startMoment.toDate();
        this.job.endDate = endMoment.toDate();
    // tslint:disable-next-line: semicolon
    };

    billingSame = (e) => {
        if (this.job.isBillingAddress) {
            this.job.billingAddress1 = this.job.jobAddress1;
            this.job.billingAddress2 = this.job.jobAddress2;
            this.job.billingCity = this.job.jobCity;
            this.job.billingState = this.job.jobState;
            this.job.billingZip = this.job.jobZip;
        } else {
            this.job.billingAddress1 = '';
            this.job.billingAddress2 = '';
            this.job.billingCity = '';
            this.job.billingState = '';
            this.job.billingZip = '';
        }
        // tslint:disable-next-line: semicolon
    };

    async save() {
        const success = await Promise.resolve(this.validate());
        if (!success) return;

        this.result.next({ success: true });
    }

    validate() {
        if (this.mode === 'edit') return true;
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }

        return true;
    }

    cancel() {
        this.uow.rollback();
        this.modalRef.hide();
    }
}
